import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import PublicEventsContext from './PublicEventsContext';
import useIsMobile from '../../../hooks/useIsMobile';

// Components
import PublicEventsList from './PublicEventsList';
import ButtonSet from '../../shared/ButtonSet';
import ErrorBoundary from '../../shared/ErrorBoundary';
import { PublicEventsCalendar } from './PublicEvents.imports-loadable';

import styles from './PublicEvents.module.postcss';

export const EVENT_MODE = {
  LIST: 'list',
  CALENDAR: 'calendar',
};

function PublicEvents({ truckId, locationId, location, image, description, scrollTo }) {
  const [mode, setMode] = useState(EVENT_MODE.LIST);
  const isMobile = useIsMobile();

  const eventsContext = useMemo(() => ({
    truckId,
    locationId,
    location,
    image,
    description,
    scrollTo,
  }), [truckId, locationId, location, description, image, scrollTo]);

  const onActivateList = () => {
    setMode(EVENT_MODE.LIST);
  };

  const onActivateCalendar = () => {
    setMode(EVENT_MODE.CALENDAR);
  };

  // Set to list if switching to mobile
  useEffect(() => {
    if (isMobile) {
      setMode(EVENT_MODE.LIST);
    }
  }, [isMobile]);

  return (
    <div>
      <div className={styles.Events_controls + ' u-mb2'}>
        <h2 className='u-mb0'>Schedule</h2>
        <ButtonSet className={styles.Events_modeControls}>
          <button
            type='button'
            disabled={mode === EVENT_MODE.LIST}
            onClick={onActivateList}
          >
            List
          </button>
          <button
            type='button'
            disabled={mode === EVENT_MODE.CALENDAR}
            onClick={onActivateCalendar}
          >
            Calendar
          </button>
        </ButtonSet>
      </div>

      <PublicEventsContext.Provider value={eventsContext}>
        <div>
          { mode === EVENT_MODE.LIST &&
            <PublicEventsList />
          }
          {/* A calendar error leaves the panel empty instead of replacing the
              whole page with the error screen. Switching to List and back
              remounts it for a retry. */}
          { mode === EVENT_MODE.CALENDAR &&
            <ErrorBoundary name='PublicEventsCalendar'>
              <PublicEventsCalendar />
            </ErrorBoundary>
          }
        </div>
      </PublicEventsContext.Provider>
    </div>
  );
}

PublicEvents.propTypes = {
  truckId: PropTypes.string,
  locationId: PropTypes.number,
  location: PropTypes.object,
  image: PropTypes.string,
  description: PropTypes.string,
  scrollTo: PropTypes.string,
};

export default PublicEvents;
